import React from "react";
import { DASHBOARD_VIEWS, GA4_DASHBOARD_VIEWS } from "./dashboardViews";

const DashboardSidebar = ({ activeView, onChange, ga4Connected }) => (
  <nav className="owner-dashboard__sidebar" aria-label="Dashboard navigation">
    <p className="owner-dashboard__sidebar-heading">Sections</p>
    <ul className="owner-dashboard__nav-list">
      {DASHBOARD_VIEWS.map((view) => {
        const isActive = activeView === view.id;
        const showWarn = GA4_DASHBOARD_VIEWS.includes(view.id) && !ga4Connected;

        return (
          <li key={view.id}>
            <button
              type="button"
              className={`owner-dashboard__nav-item${
                isActive ? " owner-dashboard__nav-item--active" : ""
              }`}
              aria-current={isActive ? "page" : undefined}
              onClick={() => onChange(view.id)}
            >
              <span className="owner-dashboard__nav-item-label">{view.label}</span>
              {view.shortLabel && (
                <span
                  className="owner-dashboard__nav-item-label owner-dashboard__nav-item-label--short"
                  aria-hidden="true"
                >
                  {view.shortLabel}
                </span>
              )}
              {view.source && (
                <span className="owner-dashboard__nav-item-source">{view.source}</span>
              )}
              {showWarn && (
                <span className="owner-dashboard__nav-item-badge">Limited</span>
              )}
            </button>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default DashboardSidebar;
